<template>
    <div class="bg-black position-absolute w-100 h-100 d-flex justify-content-center align-items-center">
        <span id="skip" @click="$emit('introductionComplete')">Skip</span>

        <img class="img-fluid position-absolute" id="logo-1" src="../assets/img/BiSwiss.png">
        <img class="img-fluid position-absolute" id="logo-2" src="../assets/img/faviconWhite.png">

        <span class="ml h1-epk labgrotesque-bold position-absolute ml-3 mr-3" :id="'ml-' + index" v-for="(phrase, index) in phrases" :style="'color: ' + phrase.field_colore" v-html="phrase.body"></span>
    </div>
</template>

<script>
export default {
    name: 'movingletters',

    props: {
        phrases: Array
    },

    mounted() {
        this.setMovingLetters();
    },

    data() {
        return {
            widthLogo2: this.$root.getClassSize() == "xl" ? 160 : 100,
            heightLogo2: this.$root.getClassSize() == "xl" ? 222 : 139,
        }
    },

    methods: {
        setMovingLetters() {
            var thisObj = this;
            var animation = this.$root.animejs.timeline({loop: false})
            .add({
                targets: '#logo-1',
                opacity: [0,1],
                easing: "easeInOutQuad",
                duration: 1000
            })
            .add({
                targets: '#logo-1',
                opacity: 0,
                duration: 1000,
                easing: "easeOutExpo",
                delay: 1000
            })
            .add({
                targets: '#logo-2',
                opacity: [0,1],
                easing: "easeInOutQuad",
                duration: 1000
            })
            .add({
                targets: '#logo-2',
                scale: 0.5,
                translateX: 40 - ($("#logo-2").offset().left * 2) + (thisObj.widthLogo2 / 2),
                translateY: 20 - ($("#logo-2").offset().top * 2) + (thisObj.heightLogo2 / 2),
                duration: 1500,
                easing: 'easeInOutExpo'                              
            });

            var thisObj = this;
            $.each(this.phrases, function(index, value) {
                $('#ml-' + index).html($('#ml-' + index).text().replace(/\S/g, "<span class='letter'>$&</span>"));

                animation.add({
                    targets: '#ml-' + index + ' .letter',
                    opacity: [0,1],
                    easing: "easeInOutQuad",
                    duration: 1000,
                    delay: (el, i) => 25 * (i+1)
                }, "-=500")
                .add({
                    targets: '#ml-' + index,
                    opacity: 0,
                    duration: 1000,
                    easing: "easeOutExpo",
                    delay: 1000,
                    complete: function(anim) {
                        if(index === thisObj.phrases.length - 1) {
                            thisObj.$emit("introductionComplete");
                        }
                    }
                });
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/introduction.vue